<script setup>
import CrossIcon from "@/components/icons/CrossIcon.vue";
import {useTableStore} from "@/stores/table";
import {onMounted, ref} from "vue";
import TagSelector from "@/components/table/CreateFeed/TagSelector.vue";
import {useSources} from "@/stores/sources-store";

onMounted(async() => {
  isLoading.value = true;
  const rows = tableStore.activeRow.tags || [];
  tagList.value = await Promise.all(
      rows.map(async row => ({
        category_active: row.category,
        tag_list: await sourcesStore.getTagByCategory(row.category),
        tag_active: { name: row.name, id: row.id }
      }))
  );
  isLoading.value = false;
});

const isLoading = ref(true);

const sourcesStore = useSources();
const tableStore = useTableStore();

const tagList = ref([]);

const source = ref(tableStore.activeRow);
const tagIds = ref([]);

const updateTagIds = (tagList) => {
  tagIds.value = tagList;
};

const updateSource = async () => {
  await sourcesStore.updateSourceTag(tagIds.value, source.value.id);
};
</script>

<template>
  <div class="wrapper">
    <div class="header">
      <div class="header__title">
        Редактирование тегов
      </div>
      <div class="header__button-close">
        <CrossIcon @click="tableStore.createTagModalIsActive = false" />
      </div>
    </div>

    <div class="body__source-name">
      {{ source.name }}
    </div>

    <div class="body">
      <TagSelector
        v-if="!isLoading"
        :tag-list="tagList"
        @update-tag-ids="args => updateTagIds(args)"
      />
    </div>
    <div class="footer">
      <ButtonAccentPrimary
        size="large"
        :pressed="false"
        class="navbar__action-button"
        @click="updateSource"
      >
        Сохранить
      </ButtonAccentPrimary>
      <ButtonNeutralSecondary
        size="large"
        :pressed="false"
        class="navbar__action-button"
        @click="tableStore.createTagModalIsActive = false"
      >
        Отмена
      </ButtonNeutralSecondary>
    </div>
  </div>
</template>

<style scoped lang="scss">

.wrapper {
  position: fixed;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  width: 450px;
  height: 100%;
  padding: 20px;
  background: #FFF;
  box-shadow: 0 4px 20px 0 #00000026;
  gap: 30px;
  z-index: 2000;

  .footer {
    position: absolute;
    bottom: 20px;
    width: 410px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 24px;
    z-index: 210;
  }

  .body {
    display: flex;
    flex-direction: column;
    max-height: 80%;
    border-radius: 8px;
    background: #F7F8FD;

    &__title {
      font-size: 16px;
      font-weight: 500;
      color: #7B87A5;
    }

    &__source-name {
      font-size: 28px;
      font-weight: 400;
      color: #1890FF;
    }

    &-tag-list {
      gap: 20px;
      overflow-y: auto;
      padding-right: 18px;
      margin-right: -18px;
      height: calc(100vh - 388px);
      scrollbar-color: #cadbf5 transparent;

      // WebKit styles (Chrome, Safari, Edge)
      &::-webkit-scrollbar {
        width: 12px;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
        border-radius: 6px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #cadbf5;
        border-radius: 6px;
      }

      &__item {
        position: relative;
        width: 100%;
        margin-top: 24px;
        & input {
          border: 1px solid var(--outline-input);
          border-radius: 8px;
          padding: 8px 12px;
          width: 100%;
          height: 40px;
          font-size: 14px;
          &::placeholder {
            color: var(--outline-grey3);
          }
        }
        & select {
          width: 100%;
          height: 40px;
          padding: 10px 12px;
          background: white;
          border: 1px solid var(--outline-input);
          border-radius: 8px;
          font-size: 14px;
        }
        &--remove {
          position: absolute;
          right: 0;
          top: 6px;
          cursor: pointer;
        }
      }

      &__item-subtitle {
        font-family: var(--font-family);
        font-weight: 400;
        font-size: 14px;
        line-height: 140%;
        color: var(--outline-grey3);
        margin-bottom: 10px;
      }
    }
  }

  .header {
    display: flex;
    justify-content: space-between;

    &__title {
      font-size: 16px;
      font-weight: 500;
      color: #212327;
    }

    &__button-close {
      cursor: pointer;
      user-select: none;
      color: #A7A7A7;
    }
  }

}
</style>